import { render, staticRenderFns } from "./appleft.vue?vue&type=template&id=45f44d6c&scoped=true&"
import script from "./appleft.vue?vue&type=script&lang=js&"
export * from "./appleft.vue?vue&type=script&lang=js&"
import style0 from "./appleft.vue?vue&type=style&index=0&id=45f44d6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f44d6c",
  null
  
)

export default component.exports